import React, { useEffect, useState, useMemo } from 'react';
import Sales from '../../components/sales/Sales';
import { useDispatch, useSelector } from 'react-redux';
import DeleteModal from '../../components/common/ConfirmModal';
import styled from 'styled-components';
import client, { url } from '../../lib/api/client';
import RunningTrackComponent from '../../components/runningtrack/RunningTrackComponent';
import AddAdsModal from '../../components/runningtrack/AddAdsModal';
import { uploadImageToServer } from '../../lib/commonFunc/commonFunc';
import EditAdsModal from '../../components/runningtrack/EditAdsModal';


const Modal = styled.div`
  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.01);
  background-color: #fff;
`;

const RunningTrackContainer = () => {
    const [mainAds, setMainAds] = useState([])
    const [bannerAds, setBannerAds] = useState([])
    const [sideAds, setSideAds] = useState([])

    const [pointActive, setPointActive] = useState(0)
    const [shortRacePointData, setShortRacePointData] = useState([])
    const [longRacePointData, setLongRacePointData] = useState([])
    const [originalShortRacePointData, setOriginalShortRacePointData] = useState([]);
    const [originalLongRacePointData, setOriginalLongRacePointData] = useState([]);

    const [shortRaceGiftPointData, setShortRaceGiftPointData] = useState([])
    const [longRaceGiftPointData, setLongRaceGiftPointData] = useState([])
    const [originalShortRaceGiftPointData, setOriginalShortRaceGiftPointData] = useState([]);
    const [originalLongRaceGiftPointData, setOriginalLongRaceGiftPointData] = useState([]);
    
    const [originalPointActive, setOriginalPointActive] = useState(0);

    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [deleteTargetId, setDeleteTargetId] = useState(null);
    const [addModalOpen, setAddModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editTarget, setEditTarget] = useState(null);
    const [addType, setAddType] = useState('');

    const {
        club
      } = useSelector(({ club }) => ({
        club: club.defaultClub,
      }));

    const onOpenMusicPlayer = () => {
        if (!club) {
            alert('클럽 정보가 없습니다.');
            return;
        }

        // 먼저 안내/다운로드 페이지를 띄운다. 웹으로만 틀면 창을 항상 열어둬야 한다는 걸
        // 여기서 알리고, '웹페이지에서 보기'를 누르면 같은 창에서 재생 화면으로 넘어간다.
        // 클럽 정보는 쿼리스트링으로 그대로 전달된다.
        const musicUrl = `/runningtrack/musicdownload?clubId=${club.clubID}&clubName=${encodeURIComponent(club.clubName || '')}`;
        window.open(
            musicUrl,
            'runningtrackMusicPlayer',
            // 음악 플레이어는 너무 크지 않게 900x700 정도로 제한
            'width=1100,height=700,menubar=no,toolbar=no,location=no,status=no,resizable=yes,scrollbars=yes'
        );
    };

    const initAds = async () => {
        console.log('club : ', club)
        if(club) {
            const res = await client.get(`${url}/api/runningtrack/ads/${club.clubID}`)
            console.log('runningtrack/ads get : ', res)
            setMainAds(res.data.mainAds)
            setBannerAds(res.data.bannerAds)
            setSideAds(res.data.sideAds)
        }
    }
    const initPoint = async () => {
        console.log('club : ', club)
        if(club) {
            const res = await client.get(`${url}/api/runningtrack/clubpointinfo/${club.clubID}`)
            console.log('runningtrack/point get : ', res.data.resultData)
            setPointActive(res.data.resultData.pointActive)
            setShortRacePointData(res.data.resultData.shortRacePointData)
            setLongRacePointData(res.data.resultData.longRacePointData)
            setShortRaceGiftPointData(res.data.resultData.shortRaceGiftPointData)
            setLongRaceGiftPointData(res.data.resultData.longRaceGiftPointData)


            // 원본 데이터 저장
            setOriginalPointActive(res.data.resultData.pointActive)
            setOriginalShortRacePointData(res.data.resultData.shortRacePointData)
            setOriginalLongRacePointData(res.data.resultData.longRacePointData)
            setOriginalShortRaceGiftPointData(res.data.resultData.shortRaceGiftPointData)
            setOriginalLongRaceGiftPointData(res.data.resultData.longRaceGiftPointData)
        }
    }

    useEffect(() => {
        initAds()
        initPoint()
    }, [club])

    const onAdsDelete = async (id)=>{
        console.log('onAdsDelete : ', id)
        setDeleteTargetId(id);
        setDeleteModalOpen(true);
    }
    const onAdsDeleteCommit = async () => {
        try {
            await client.delete(`${url}/api/runningtrack/ads/${deleteTargetId}`);
            await initAds();
            setDeleteModalOpen(false);
        } catch (error) {
            console.error('Delete failed:', error);
            alert('삭제 중 오류가 발생했습니다.');
        }
    };

    const onAdsAdd = async (type)=>{
        setAddType(type);
        setAddModalOpen(true);
    }

    const onAddCommit = async (selectedFile, type, mediaType, duration) => {
        try {
            const _now = Date.now()
            const fileName = `runningTrack_ads_${club.clubID}_${_now}${mediaType == "image"?".png":".mp4"}`
            const uploadResult = await uploadImageToServer(selectedFile, fileName, 'runningtrack/ads', mediaType == "image"?".png":".mp4")

            let res = await client.post(`${url}/api/runningtrack/ads/${club.clubID}`, {  adsType:addType, fileType: mediaType, duration: duration, url: fileName });

            console.log("uploadResult : ", res)
            await initAds();
            setAddModalOpen(false);
        } catch (error) {
            console.error('Add failed:', error);
            alert('추가 중 오류가 발생했습니다.');
        }
    };

    const getTypeText = (type) => {
        switch (type) {
            case 'main':
                return '런닝머신앱 대기화면';
            case 'banner':
                return '티비앱';
            case 'side':
                return '런닝머신앱 운동장';
            default:
                return '';
        }
    };

    const onAdsEdit = (ad) => {
        setEditTarget(ad);
        setEditModalOpen(true);
    };

    const onChangePointActive = (value) => {
        if(value == 1 && shortRacePointData.length == 0) {
            setShortRacePointData([{
                minRank:2, maxRank:10, point1:0, point2:0, point3:0
            }])
        }
        if(value == 1 && longRacePointData.length == 0) {
            setLongRacePointData([{
                minRank:2, maxRank:10, point1:0, point2:0, point3:0
            }])
        }
        if(value == 0) {
            setShortRacePointData([])
            setLongRacePointData([])
            setShortRaceGiftPointData([])
            setLongRaceGiftPointData([])
        }
        setPointActive(value);
    };

    const onAddPointSetting = (raceType, newSetting) => {
        if (raceType === 'short') {
            setShortRacePointData([...shortRacePointData, newSetting]);
        } else if (raceType === 'long') {
            setLongRacePointData([...longRacePointData, newSetting]);
        } else if (raceType === 'shortgift') {
            setShortRaceGiftPointData([...shortRaceGiftPointData, newSetting]);
        } else {
            setLongRaceGiftPointData([...longRaceGiftPointData, newSetting]);
        }
    };

    const onDeletePointSetting = (raceType, index) => {
        if (raceType === 'short') {
            const newData = shortRacePointData.filter((_, i) => i !== index);
            setShortRacePointData(newData);
        } else if(raceType === 'long') {
            const newData = longRacePointData.filter((_, i) => i !== index);
            setLongRacePointData(newData);
        } else if(raceType === 'shortgift') {
            const newData = shortRaceGiftPointData.filter((_, i) => i !== index);
            setShortRaceGiftPointData(newData);
        } else {
            const newData = longRaceGiftPointData.filter((_, i) => i !== index);
            setLongRaceGiftPointData(newData);
        }
    };

    const onUpdatePointSetting = (raceType, index, field, value) => {
        if (raceType === 'short') {
            const newData = [...shortRacePointData];
            newData[index] = { ...newData[index], [field]: value };
            setShortRacePointData(newData);
        } else if (raceType === 'long') {
            const newData = [...longRacePointData];
            newData[index] = { ...newData[index], [field]: value };
            setLongRacePointData(newData);
        } else if (raceType === 'shortgift') {
            const newData = [...shortRaceGiftPointData];
            newData[index] = { ...newData[index], [field]: value };
            setShortRaceGiftPointData(newData);
        } else {
            const newData = [...longRaceGiftPointData];
            newData[index] = { ...newData[index], [field]: value };
            setLongRaceGiftPointData(newData);
        }
    };

    const validatePointSettings = (shortData, longData, shortGiftData, longGiftData) => {
        const errors = [];
        const isEmpty = (v) => v === undefined || v === null || v === '' || Number.isNaN(v);

        // 각 경기별로 검증
        const validateRaceData = (data, raceName) => {
            if (data.length === 0) return;
            
            // 1. 참가인원이 중간에 비어있으면 안됨 (2~3 설정 + 5~6 설정)
            const sortedData = [...data].sort((a, b) => a.minRank - b.minRank);
            for (let i = 0; i < sortedData.length - 1; i++) {
                const current = sortedData[i];
                const next = sortedData[i + 1];
                if (current.maxRank + 1 !== next.minRank) {
                    errors.push(`${raceName}: 참가인원 설정이 연속되지 않습니다. (${current.maxRank} 다음에 ${next.minRank})`);
                }
            }
            
            // 2. 참가인원 설정은 2명부터는 반드시 있어야 함
            // if (sortedData[0].minRank > 2) {
            //     errors.push(`${raceName}: 참가인원 설정은 2명부터 시작해야 합니다.`);
            // }
            
            // 3. 각 설정별 포인트 검증
            sortedData.forEach((setting, index) => {
                // 필수값 누락
                if (isEmpty(setting.minRank)) {
                  errors.push(`${raceName} 설정 ${index + 1}: 최소 인원을 입력해 주세요.`);
                }
                if (isEmpty(setting.maxRank)) {
                  errors.push(`${raceName} 설정 ${index + 1}: 최대 인원을 입력해 주세요.`);
                }
                if (isEmpty(setting.point1)) {
                  errors.push(`${raceName} 설정 ${index + 1}: 1등 포인트를 입력해 주세요.`);
                }
                if (isEmpty(setting.point2)) {
                  errors.push(`${raceName} 설정 ${index + 1}: 2등 포인트를 입력해 주세요.`);
                }
                if (isEmpty(setting.point3)) {
                  errors.push(`${raceName} 설정 ${index + 1}: 3등 포인트를 입력해 주세요.`);
                }

                // 4. minRank가 maxRank보다 크면 안됨
                if (setting.minRank > setting.maxRank) {
                    errors.push(`${raceName} 설정 ${index + 1}: 최소 인원이 최대 인원보다 클 수 없습니다.`);
                }
                
                // 5. 1등 2등 3등 모두 0이면 안됨
                if (setting.point1 === 0 && setting.point2 === 0 && setting.point3 === 0) {
                    errors.push(`${raceName} 설정 ${index + 1}: 최소 하나의 포인트를 설정해야 합니다.`);
                }
                
                // 6. 2등 설정시 1등은 꼭 설정되어야 함
                if (setting.point2 > 0 && setting.point1 === 0) {
                    errors.push(`${raceName} 설정 ${index + 1}: 2등 포인트가 설정되어 있으면 1등 포인트도 설정해야 합니다.`);
                }
                
                // 7. 3등 설정시 1등 2등 모두 값이 있어야 함
                if (setting.point3 > 0 && (setting.point1 === 0 || setting.point2 === 0)) {
                    errors.push(`${raceName} 설정 ${index + 1}: 3등 포인트가 설정되어 있으면 1등, 2등 포인트도 설정해야 합니다.`);
                }
            });
        };
        
        validateRaceData(shortData, '1km 경기 결과 보상');
        validateRaceData(longData, '2.4km 경기 결과 보상');
        validateRaceData(shortGiftData, '1km 경기 선물 보상');
        validateRaceData(longGiftData, '2.4km 경기 선물 보상');
        
        return errors;
    };

    const onEditPoint = async () => {
        try {
            if(pointActive == 1) {
                // 사전 검사 실행
                const validationErrors = validatePointSettings(shortRacePointData, longRacePointData, shortRaceGiftPointData, longRaceGiftPointData);
                
                if (validationErrors.length > 0) {
                    alert(validationErrors.join('\n'));
                    return { success: false };
                }
            }

            let res = await client.post(`${url}/api/runningtrack/clubpointinfo/${club.clubID}`, {
                pointData:{
                    pointActive: pointActive,
                    shortRacePointData: shortRacePointData,
                    longRacePointData: longRacePointData,
                    shortRaceGiftPointData: shortRaceGiftPointData,
                    longRaceGiftPointData: longRaceGiftPointData
                }
            });
            
            if(res && res.data && res.data.result == 1) {
                // 저장 성공 시 원본 데이터 업데이트
                setOriginalPointActive(pointActive);
                setOriginalShortRacePointData([...shortRacePointData]);
                setOriginalLongRacePointData([...longRacePointData]);
                setOriginalShortRaceGiftPointData([...shortRaceGiftPointData]);
                setOriginalLongRaceGiftPointData([...longRaceGiftPointData]);
            
                alert('포인트 설정이 저장되었습니다.');
                return { success: true };
            }
            else {
                alert('포인트 설정 저장에 실패하였습니다.');
                return { success: false };
            }
        } catch (error) {
            console.error('Point update failed:', error);
            alert('포인트 설정 저장 중 오류가 발생했습니다.');
            return { success: false };
        }
    };

    const onEditCommit = async (adsId, duration) => {
        try {
            await client.patch(`${url}/api/runningtrack/ads/${adsId}`, {
                duration: duration
            });
            await initAds();
            setEditModalOpen(false);
            setEditTarget(null);
        } catch (error) {
            console.error('Edit failed:', error);
            alert('수정 중 오류가 발생했습니다.');
        }
    };
    return (
        <>
            <RunningTrackComponent
                onOpenMusicPlayer={onOpenMusicPlayer}
                mainAds={mainAds}
                bannerAds={bannerAds}
                sideAds={sideAds}
                onDelete={onAdsDelete}
                onAdd={onAdsAdd}
                onEdit={onAdsEdit}

                pointActive={pointActive}
                shortRacePointData={shortRacePointData}
                longRacePointData={longRacePointData}
                shortRaceGiftPointData={shortRaceGiftPointData}
                longRaceGiftPointData={longRaceGiftPointData}
                onEditPoint={onEditPoint}
                onChangePointActive={onChangePointActive}
                onAddPointSetting={onAddPointSetting}
                onDeletePointSetting={onDeletePointSetting}
                onUpdatePointSetting={onUpdatePointSetting}
                originalShortRacePointData={originalShortRacePointData}
                originalLongRacePointData={originalLongRacePointData}
                originalShortRaceGiftPointData={originalShortRaceGiftPointData}
                originalLongRaceGiftPointData={originalLongRaceGiftPointData}
                originalPointActive={originalPointActive}
            />

            <DeleteModal
                isDelete
                text={`정말 이 광고를 삭제하시겠습니까?`}
                onClick={() => {
                    onAdsDeleteCommit()
                }}
                setModal={() => {setDeleteModalOpen(false)}}
                confirmText = "삭제"
                onModal={deleteModalOpen}
            />
            <AddAdsModal
                isOpen={addModalOpen}
                onClose={() => setAddModalOpen(false)}
                type={addType}
                onConfirm={onAddCommit}
            />
            <EditAdsModal
                isOpen={editModalOpen}
                onClose={() => {
                    setEditModalOpen(false);
                    setEditTarget(null);
                }}
                ad={editTarget}
                onConfirm={onEditCommit}
            />
        </>
    );
};

export default RunningTrackContainer;
